import { Link } from 'react-router-dom';
import { PlusIcon, TrashIcon } from '@phosphor-icons/react';
import toast from 'react-hot-toast';

import { useAllGeneralSettings } from '../../all-settings-context';
import { MailboxTypeToText } from './constants';
import { ConfirmDialog } from '../../../../components/dialog/ConfirmDialog';
import { deleteMailbox } from '../../models';
import { getDisplayError } from '../../../../utils/get-display-error';
import { LinkButton } from '../../../../components/button/ButtonLink';
import { Table } from 'components/table/Table';
import { captureException } from '@sentry/react';
import { EmptyState } from 'components/empty-state/EmptyState';

const TABLE_HEADERS = [
  {
    id: 'name',
    name: 'Naam',
  },
  {
    id: 'email',
    name: 'E-Mail',
  },
  {
    id: 'type',
    name: 'Type',
  },
  {
    id: 'server',
    name: 'Server',
  },
  {
    id: 'delete',
    name: 'Verwijder',
  },
];

export const MailboxesSettingsPage = () => {
  const { settings, refreshData } = useAllGeneralSettings();

  return (
    <div className="grid gap-4">
      <div className="flex items-center justify-between gap-3">
        <h2 className="heading-two">Mailboxen</h2>

        <LinkButton to="configure" color="primary" iconLeft={<PlusIcon className="button-icon" />}>
          Nieuwe Mailbox
        </LinkButton>
      </div>

      {settings.mailboxes.length === 0 ? (
        <EmptyState
          variant="panel"
          title="Geen mailboxen geconfigureerd"
          description="Voeg een mailbox toe om inkomende e-mails automatisch te verwerken."
        />
      ) : (
        <Table
          idKey="id"
          headers={TABLE_HEADERS}
          data={settings.mailboxes}
          mapData={(mailbox) => {
            return [
              <Link to={mailbox.id} className="link-text">
                {mailbox.name}
              </Link>,
              mailbox.imapUser,
              MailboxTypeToText[mailbox.type] || 'onbekend',
              mailbox.imapHost,
              <ConfirmDialog
                triggerColor="danger"
                triggerText={<TrashIcon className="button-icon" />}
                title={`Ben je zeker dat je de mailbox ${mailbox.name} wilt verwijderen?`}
                submitText="Mailbox verwijderen"
                description={`Ben je zeker dat je de mailbox ${mailbox.name} wilt verwijderen? Om dit ongedaan te maken zal je de mailbox opnieuw moeten aanmaken.`}
                onSubmit={async () => {
                  try {
                    await deleteMailbox(mailbox.id);
                    refreshData();
                    toast.success('Mailbox verwijderd');
                  } catch (err) {
                    captureException(err);
                    toast.error(`Kon mailbox niet verwijderen: ${getDisplayError(err)}`);
                  }
                }}
              />,
            ];
          }}
        />
      )}
    </div>
  );
};
